import { Router, } from '@angular/router';
import { AppStateFacade, } from '@app-state';
import { AuthService } from '@services/auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/auth.service";
import * as i3 from "../app-state/app-state.facade";
var NoSessionGuard = /** @class */ (function () {
    function NoSessionGuard(_router, _authService, _appState) {
        this._router = _router;
        this._authService = _authService;
        this._appState = _appState;
    }
    NoSessionGuard.prototype.canActivate = function () {
        if (this._appState.user.authState === 0 /* NotLoggedIn */ ||
            this._authService.pendingLogout$.value ||
            this._appState.authConfig.value.auth.isCustomSsoEnabled) {
            return true;
        }
        this._router.navigate(['']);
        return false;
    };
    NoSessionGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NoSessionGuard_Factory() { return new NoSessionGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService), i0.ɵɵinject(i3.AppStateFacade)); }, token: NoSessionGuard, providedIn: "root" });
    return NoSessionGuard;
}());
export { NoSessionGuard };
